import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import { Tabs, Tab } from "@mui/material";

// core components
import Card from "../../components/Card/Card.js";
import CardBody from "../../components/Card/CardBody.js";
import CardHeader from "../../components/Card/CardHeader.js";

import styles from "../../assets/jss/material-dashboard-react/components/customTabsStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function CustomTabs(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, value) => {
    setValue(value);
    if (!!props?.onTabChange) props.onTabChange(value);
  };


  const { headerColor, plainTabs, tabs, title, rtlActive, className, sx } = props;


  const cardTitleData = {
    "cardTitle": true,
    "cardTitleRTL": rtlActive
  }
  const cardTitleKeys = getKeyArray(cardTitleData);


  return (
    <Card sx={sx} plain={plainTabs}>
      <CardHeader color={headerColor} plain={plainTabs}>
        {title !== undefined
          ? <div style={getBaseSxStyle(styles, [...cardTitleKeys, { fontWeight: 'bold' }])}>{title}:</div>
          : null}
        <Tabs
          value={value}
          onChange={handleChange}
          sx={getBaseSxStyle(styles, ['tabsRoot'])}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((prop, key) => {
            var icon = {};
            if (prop.tabIcon) {
              icon = {
                icon: <prop.tabIcon />
              };
            }
            return (
              <Tab
                sx={getBaseSxStyle(styles, 'tabRootButton', 'tabSelected', 'tabWrapper')}
                key={key}
                label={prop.tabName}
                {...icon}
              />
            );
          })}
        </Tabs>
      </CardHeader>
      <CardBody>
        {tabs.map((prop, key) => {
          if (key === value) {
            return <div key={key}>{prop.tabContent}</div>;
          }
          return null;
        })}
      </CardBody>
    </Card>
  );
}

CustomTabs.propTypes = {
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node.isRequired
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool
};
